/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_ProgressionInputs */

const en_control_progression = /** @type {(inputs: Control_ProgressionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuck on progression?`)
};

const zh_control_progression = /** @type {(inputs: Control_ProgressionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进度卡住了？`)
};

/**
* | output |
* | --- |
* | "Stuck on progression?" |
*
* @param {Control_ProgressionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_progression = /** @type {((inputs?: Control_ProgressionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_ProgressionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_progression(inputs)
	return zh_control_progression(inputs)
});
export { control_progression as "control.progression" }